module.exports = __webpack_public_path__ + "static/PP0s-4790b240dee1e856d295c74018981075.jpg";